import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import Card from "@material-ui/core/Card"
import CardHeader from "@material-ui/core/CardHeader"
import CardMedia from "@material-ui/core/CardMedia"
import CardContent from "@material-ui/core/CardContent"
import CardActions from "@material-ui/core/CardActions"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import Menu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import { Divider, Grid, IconButton, Box } from "@material-ui/core"
import TextField from "@material-ui/core/TextField"
import { Field, ErrorMessage } from "formik"
import { HighLightUpSVG, HighLightDownSVG } from "../icons"
import { PaginationDownSVG, PaginationUpSVG } from "../icons"
import { getFileRequestByPage, getPageNumberBasedOnHighlightTextRequest, resetPageViewerData } from "../../actions/documentModalActions"

import { useHistory } from "react-router-dom"
import _ from "lodash"
import {
	getViewerAllDocumentsRequest,
	getViewerAllDocumentsRequestReset,
	updateSkipCount,
	updateViewerPageNumber,
} from "../../actions/viewerActions"
import { getConceptBasedOnId, resetHighlightFilter, searchHighlightFilter } from "../../actions/highlightActions"
import { getRetainFiltersList, getRetainFiltersSuccess } from "../../actions/infoActions"

const useStyles = makeStyles((theme) => ({
	pagination: {
		flex: 1,
		display: "flex",
		alignItems: "center",
		padding: "10px 0",
		justifyContent: "end",
		"& .MuiInputBase-input": {
			padding: "5px 10px",
			marginRight: "10px",
			border: `solid 1px ${theme.palette.grey.D400}`,
		},
	},
}))

const ViewerDocumentListPagination = ({ retainedFilterJobData }) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const history = useHistory()
	const theme = useTheme()
	const [localSkipCount, setLocalSkipCount] = useState(1)
	const { documentDetails, pageNumberForCurrentDocument } = useSelector((state) => state.documentModal)
	const { allDocuments, allDocumentsCount } = useSelector((state) => state.viewerData)
	const highlightFilter = useSelector((state) => state.highlightFilter.search)
	const { currentPageNumber, skipCount } = useSelector((state) => state.viewerData)

	const getDataBasedOnPsearch = (updatedSkipCount) => {
		dispatch(resetPageViewerData())
		dispatch(resetHighlightFilter())
		document.getElementById("document-list-container")?.scrollIntoView(true)
		const modifiedRetainedFilterJobData = retainedFilterJobData
		const updatedRetainedFilterJobData = { ...modifiedRetainedFilterJobData, skip_count: updatedSkipCount }
		dispatch(updateSkipCount(updatedSkipCount))
		dispatch(
			getViewerAllDocumentsRequest({
				params: updatedRetainedFilterJobData,
				jobIdToRetainData: null,
			})
		)
	}

	useEffect(() => {
		if (!_.isEmpty(retainedFilterJobData)) {
			dispatch(updateSkipCount(retainedFilterJobData?.skip_count))
		}
	}, [retainedFilterJobData])

	useEffect(() => {
		if (retainedFilterJobData) {
			const params = location?.pathname?.split("/")
			const fileId = params[params.length - 1]
			let searchText = retainedFilterJobData?.text ? highlightFilter?.searchWord : []
			let selectedConcept = retainedFilterJobData?.text ? highlightFilter?.loadedConcept : []
			const payload = {
				categories: retainedFilterJobData?.categories || [],
				text: [...searchText, ...selectedConcept],
				return_count: 20000,
				skip_count: 0,
				suppress_content: false,
				neg_text: "",
				mode: "PAGE",
				treat_like_concept: false,
				selected_database: retainedFilterJobData?.selected_database,
				additional_params: {
					skip_audit: true,
					page_context: params?.[1],
				},
				restrict_file_ids: [fileId],
			}
			if (
				highlightFilter?.specificWord ||
				!_.isEmpty(retainedFilterJobData?.text) ||
				!_.isEmpty(retainedFilterJobData?.categories) ||
				!_.isEmpty(highlightFilter?.loadedConcept)
			) {
				dispatch(getPageNumberBasedOnHighlightTextRequest(payload))
			}
		}
	}, [retainedFilterJobData])

	const nextClick = () => {
		if (skipCount + parseInt(retainedFilterJobData?.return_count) < allDocumentsCount) {
			console.log(parseInt(retainedFilterJobData?.skip_count) + parseInt(retainedFilterJobData?.return_count))
			getDataBasedOnPsearch(skipCount + parseInt(retainedFilterJobData?.return_count))
			dispatch(updateViewerPageNumber(1))
			if (!_.isEmpty(retainedFilterJobData?.categories)) {
				dispatch(getConceptBasedOnId(retainedFilterJobData?.categories))
			}
			if (!_.isEmpty(retainedFilterJobData?.text)) {
				const filterData = { ...highlightFilter }
				filterData.loadedConcept = [...filterData?.loadedConcept, ...retainedFilterJobData?.text]
				dispatch(searchHighlightFilter(filterData))
			}
		}
	}

	const previousClick = () => {
		if (skipCount !== 0) {
			getDataBasedOnPsearch(skipCount - parseInt(retainedFilterJobData?.return_count))
			dispatch(updateViewerPageNumber(1))
			if (!_.isEmpty(retainedFilterJobData?.categories)) {
				dispatch(getConceptBasedOnId(retainedFilterJobData?.categories))
			}
			if (!_.isEmpty(retainedFilterJobData?.text)) {
				const filterData = { ...highlightFilter }
				filterData.loadedConcept = [...filterData?.loadedConcept, ...retainedFilterJobData?.text]
				dispatch(searchHighlightFilter(filterData))
			}
		}
	}

	return (
		<>
			<Box className={classes.pagination}>
				<Box style={{ display: "flex" }}>
					<Typography style={{ paddingRight: "5px" }}>{skipCount + 1 || 0}</Typography>-
					<Typography style={{ padding: "0 5px" }}>
						{skipCount + parseInt(retainedFilterJobData?.return_count) > allDocumentsCount
							? allDocumentsCount
							: skipCount + parseInt(retainedFilterJobData?.return_count) || 0}
					</Typography>{" "}
					of
					<Typography style={{ paddingLeft: "5px" }}>{allDocumentsCount}</Typography>
				</Box>
				<Box style={{ display: "flex" }}>
					<Box
						onClick={previousClick}
						style={{
							display: "flex",
							transform: "rotate(90deg)",
							marginLeft: "10px",
							cursor: "pointer",
							opacity: skipCount === 0 ? 0.5 : 1,
						}}
					>
						<HighLightDownSVG />
					</Box>
					<Box
						onClick={nextClick}
						style={{
							padding: "0px 10px",
							display: "flex",
							cursor: "pointer",
							transform: "rotate(90deg)",
							opacity: skipCount + parseInt(retainedFilterJobData?.return_count) >= allDocumentsCount ? 0.5 : 1,
						}}
					>
						<HighLightUpSVG />
					</Box>
				</Box>
			</Box>
		</>
	)
}

export default ViewerDocumentListPagination
